export default "__VITE_ASSET__D9l5$ANo__"